import React from 'react';
import { Box, Stack, Button, Typography } from '@mui/material';

const categoryTypes = [
  'Profile',
  'Treatment',
  'Documents'
];

interface CategoryStepProps {
  selectedCategory: string;
  setSelectedCategory: (type: string) => void;
}

const CategoryStep: React.FC<CategoryStepProps> = ({
  selectedCategory,
  setSelectedCategory,
}) => (
  <Box>
    <Typography variant="h6" fontWeight={500} mb={2}>
      Select Category :
    </Typography>
    
    <Stack direction="row" spacing={3}>
      {categoryTypes.map(type => (
        <Button
          key={type}
          variant={selectedCategory === type ? 'contained' : 'outlined'}
          color={selectedCategory === type ? 'error' : 'inherit'}
          sx={{
            bgcolor: selectedCategory === type ? '#FFEBE6' : '#F5F5F5',
            color: selectedCategory === type ? '#FF6F61' : '#888',
            minWidth: 180,
            height: 56,
            fontSize: 18,
            fontWeight: selectedCategory === type ? 600 : 400,
            borderRadius: 2,
            boxShadow: 'none',
            border: 'none',
            '&:hover': {
              bgcolor: selectedCategory === type ? '#FFEBE6' : '#e0e0e0'
            }
          }}
          onClick={() => setSelectedCategory(type)}
        >
          {type}
        </Button>
      ))}
    </Stack>
    
  </Box>
);

export default CategoryStep;
